import { render } from "./CopyrightLayout.vue?vue&type=template&id=3e6086b9"
import script from "./CopyrightLayout.vue?vue&type=script&lang=js"
export * from "./CopyrightLayout.vue?vue&type=script&lang=js"

import "./CopyrightLayout.vue?vue&type=style&index=0&id=3e6086b9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__